import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { Polls, Payload } from '../types';

interface PollsList extends BaseResponse, ApiPagination {
  data: {
    items: Polls.Poll[],
  }
}

interface PollResponse {
  data: Polls.CurrentPoll
}

export class PollsService extends BaseApiService {
  private readonly base_path = 'polls';

  async get_polls(filters: FiltersPagination<Filters>): Promise<PollsList> {
    const payload = filters;

    const { data } = await this.http_client.get<PollsList>(this.base_path, {
      params: {
        filters: payload.filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_poll_by_id(id: string | number): Promise<PollResponse> {
    const url = `${this.base_path}/${id}`;
    const { data } = await this.http_client.get<PollResponse>(url);

    return data;
  }

  async send_result(id: string | number, payload: Payload): Promise<number | number> {
    const url = `${this.base_path}/${id}/result`;

    const { data } = await this.http_client.post<Response<null>>(url, payload);

    return data.code;
  }
}
